const mailFees = [
  ['No Mail Fee', 'No Mail Fee|0.00'],
  ['Custom Mail Fee (Enter Your Own Below)', 'Custom|0.00'],
  ['Mail Decal', 'Mail Decal|0.75'],
  ['Mail License Plate', 'Mail License Plate|2.95'],
  ['Mail (5) Temporary Plates & 83091\'s', 'Mail (5) Temporary Plates & 83091s|2.55'],
  ['Mail (10) Temporary Plates & 83091\'s', 'Mail (10) Temporary Plates & 83091s|3.10'],
  ['Mail (25) Temporary Plates & 83091\'s', 'Mail (25) Temporary Plates & 83091s|5.60'],
];

export default mailFees;



// WEBPACK FOOTER //
// ./src/modules/data/mail-fees.js